<template>
<vx-card>
    <!--CURSOS-->
    <div v-if="menu == 0">
        <vs-button class="mt-2" @click="activePrompt = true">Agregar curso</vs-button>
        <div class="m-4" v-if="cursos.length ==0">
            <h4 style="color: darkgray;"><i>Registra en esta sección, el código de curso envido por tu profesor.</i></h4>
        </div>
        <vs-prompt title="Agregar curso" @cancel="idlibro=''" @accept="acceptAlert" @close="close" acceptText="Aceptar" cancelText="Cancelar" :active.sync="activePrompt">
            <div class="con-exemple-prompt">
                <vs-alert>
                    Ingresa el código del curso, enviado por su docente.
                </vs-alert>
                <br>
                <vs-input icon-after="true" class="mt-4 w-full" icon="code" label-placeholder="QWERTY" v-model="codigo" />
            </div>
        </vs-prompt>
        <!--CURSOS-->
        <div class="containerCurso mt-3">
            <div class="profile-card" v-for="(section,index) in cursos" :key="index">
                <div class="card-header">
                    <div class="pic">
                        <img src="./img/curso.png" alt="">
                    </div>
                    <div class="name">{{ section.materia }}</div>
                    <div class="desc">Grado: {{ section.grado }}</div>
                    <div class="docente">Docente: {{ section.docente }}</div>
                    <span class="contact-btn cursor-pointer" @click="abrirCurso(section);">Ver curso</span>
                </div>
                <div class="card-footer">
                    <div class="numbers">
                        <div class="item">
                            <span>{{ section.paralelo }}</span>
                            Paralelo
                        </div>
                        <div class="border"></div>
                        <div class="item">
                            <span>{{ section.codigo }}</span>
                            Código
                        </div>
                        <div class="border"></div>
                        <div class="item">
                            <span>{{ section.updated_at.substring(0,10) }}</span>
                            Creado
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--RECURSOS-->
    <div v-if="menu == 1">
       
    </div>
</vx-card>
</template>

<script>
export default {
    data() {
        return {
            cursos: [],
            curso: [],
            usuario: [],
            activePrompt: false,
            codigo: '',
            menu: 0,
            codigoCurso: '',
            materia: '',
            titleCurso: '',
            datos: {},
        }
    },
    created() {
        this.usuario = JSON.parse(localStorage.getItem('usuario'))[0];
    },
    mounted() {
        let me = this;
        me.getCurso();
    },
    methods: {
        abrirCurso(tr) {
            let me = this;
            // console.log(tr)
            me.materia = tr.materia
            me.titleCurso = "Materia: " + tr.materia + " Código: " + tr.codigo
            me.codigoCurso = tr.codigo
            localStorage.setItem('idlibro', tr.id_asignatura)
            localStorage.setItem('idasignatura', tr.id_asignatura)
            localStorage.setItem('codigo_curso', tr.codigo)
            localStorage.setItem('nombreasignatura', tr.nombrelibro)
            localStorage.setItem('docente', tr.docente)
            me.datos = {
                'docente': tr.docente,
                'libro': tr.nombrelibro,
                'codigo': tr.codigo,
            }
            me.$router.push('/estudiante/evaluaciones')
        },
        getCurso() {
            let me = this;
            me.$vs.loading()
            this.$http.get(this.$server_url + 'estudianteCurso?idusuario=' + me.usuario.idusuario)
                .then(function (response) {
                    console.log('response cursos',response.data);
                    me.cursos = response.data;
                    me.$vs.loading.close()
                })
                .catch(function () {
                    me.$vs.loading.close()

                })
        },
        acceptAlert() {
            let me = this;
            let formData = new FormData();
            if (!me.codigo) {
                me.$vs.notify({
                    color: 'warning',
                    title: 'Ingresa el código del curso enviado por tu docente.',
                })
                return
            } else {
                formData.append('codigo', me.codigo);
                formData.append('idusuario', me.usuario.idusuario);
                formData.append('periodo_id', localStorage.periodo_id);
                me.$vs.loading()
                this.$http.post(this.$server_url + 'addClase', formData)
                    .then(function (response) {
                        me.$vs.loading.close()
                        me.getCurso();
                        if (response.data.status == '1') {
                            me.$vs.notify({
                                text: response.data.message,
                                color: 'primary',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            })
                            me.codigo = ''
                            // window.location.reload(); 
                        } else {
                            me.$vs.notify({
                                text: response.data.message,
                                color: 'primary',
                                iconPack: 'feather',
                                icon: 'icon-alert-triangle'
                            })
                            me.codigo = ''
                        }
                    })
                    .catch(function () {
                        me.$vs.loading.close()
                    })
            }
        },
        close() {
            this.$vs.notify({
                color: 'danger',
                title: '',
                text: 'El curso no fue registrado!'
            })
        },
    },
}
</script>

<style lang="css" scoped>
.modal-mask {
    position: fixed;
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 700px;
    z-index: 999;
    margin: 0px auto;
    padding: 10px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 10px;
    color: #42b983;
}

.modal-body {
    margin: 5px 0;
}

.modal-default-button {
    float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.btn-opciones {
    display: inline-block;
    cursor: pointer;
    background-color: rgb(255, 252, 248);
    padding: 5px;
    border: solid 1px rgb(248, 240, 231);
    border-radius: 10px;
}

.btn-opciones:hover {
    background-color: rgb(248, 240, 231);
}

/**ESTILOS CURSOS CARD */
* {
    margin: 0;
    padding: 0;
    font-family: 'Inter', 'sans-serif';
    box-sizing: border-box;
    text-decoration: none;
}

.containerCurso {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100% !important;
}

.profile-card {
    width: 400px;
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
    margin: 10px;
    border-radius: 10px;
    box-shadow: #bbb 6px 8px;
}

.card-header {
    background: #2c3a47;
    padding: 30px 10px;
}

.pic {
    display: inline-block;
    padding: 8px;
    background: linear-gradient(130deg, #74b9ff, #e66767);
    margin: auto;
    border-radius: 50%;
    background-size: 200% 200%;
    animation: animated-gradient 2s linear infinite;
}

@keyframes animated-gradient {
    25% {
        background-position: left bottom;
    }

    50% {
        background-position: right bottom;
    }

    75% {
        background-position: right top;
    }

    100% {
        background-position: left top;
    }
}

.pic img {
    display: block;
    width: 80px;
    height: 80px;
    border-radius: 50%;
}

.name {
    color: #f2f2f2;
    font-size: 28px;
    font-weight: 600;
    margin: 10px 0;
}

.desc {
    font-size: 18px;
    color: #e66767;
}

.docente {
    font-size: 18px;
    color: #adaf81;
}

.sm {
    display: flex;
    justify-content: center;
    margin: 20px 0;
}

.sm a {
    color: #f2f2f2;
    width: 56px;
    font-size: 22px;
    transition: .3s linear;
}

.sm a:hover {
    color: #e66767;
}

.contact-btn {
    display: inline-block;
    padding: 12px 50px;
    color: #E5834B !important;
    border: 2px solid #e66767;
    border-radius: 6px;
    margin-top: 16px;
    transition: .3s linear;
}

.contact-btn:hover {
    background: #e66767;
    color: #f2f2f2 !important;
}

.card-footer {
    background: #f4f4f4;
    padding: 30px 10px;
}

.numbers {
    display: flex;
    align-items: center;
}

.item {
    flex: 1;
    text-transform: uppercase;
    font-size: 11px;
    color: #e66767;
}

.item span {
    display: block;
    color: #2c3a47;
    font-size: 13px;
    font-weight: 600;
}

.border {
    width: 1px;
    height: 30px;
    background: #bbb;
}

.btnCurso {
    background-color: black;
    border-radius: 10px;
    padding: 12px;
    color: white;
    cursor: pointer;
}

.btnCurso:hover {
    opacity: 0.8;
}

.bg-fondo-1 {
    background-color: rgba(var(--vs-white1), 1) !important;
    border-radius: 10px;
}
</style>
